import { FleekError } from './FleekError';

type StorageUploadTotalSizeQuotaExceededErrorOptions = {
  quota?: number;
};

export class StorageUploadTotalSizeQuotaExceededError extends FleekError<StorageUploadTotalSizeQuotaExceededErrorOptions> {
  public name = 'StorageUploadTotalSizeQuotaExceededError';

  constructor(data: StorageUploadTotalSizeQuotaExceededErrorOptions = {}) {
    super(data);
  }

  toString = () => {
    if (this.data?.quota) {
      return `Sorry, you have reached your daily upload limit of ${Math.round(
        this.data.quota / 1000 ** 3
      )}GB. We are unable to process your request.`;
    }

    return 'You have exceeded your storage upload quota for the last 24 hours.';
  };
}
